export const defaultLayoutState = {
	TaxPaper: [],
	TaxReturnSubmission: [],
	Notification: []
};

export default {
	...defaultLayoutState
};
